<template>
  <div class="content">
    <table class="table-container">
      <tr class="table-header">
        <th>Номер участка</th>
        <th>Кадастровый номер</th>
        <th>Регион</th>
        <th>Район</th>
        <th>Площадь участка</th>
        <th>Тип участка</th>
        <th>Подтип</th>
        <th>Категория</th>
        <th>Тип использования</th>
        <th>Юридический адрес</th>
      </tr>
      <tr class="table-row">
        <td>{{ data.NUMBER }}</td>
        <td>{{ data.KADASTR }}</td>
        <td>{{ data.REGION }}</td>
        <td>{{ data.DISTRICT }}</td>
        <td>{{ false }}</td>
        <td>{{ false }}</td>
        <td>{{ false }}</td>
        <td>{{ false }}</td>
        <td>{{ false }}</td>
        <td>{{ false }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "TabData",
  data() {
    return {
      id: this.$route.params.id,
      url: config.backend_url,
      data: {}
    };
  },
  computed: {},
  watch: {},
  methods: {
    getPlotData: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "plots/get-plot-data/",
          data: { ID: this.id },
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          console.log(data);
          if (!data.error) this.data = data;
        });
    }
  },
  created() {
    this.getPlotData();
  }
};
</script>
